export const PRIMARY_DARK_BLUE = "#145486";
export const PRIMARY_LIGHT_BLUE = "#109CF1";
export const GREY_LIGHT = "#E6E6E6";
export const COLOR_BG = "#F5F6F8";
// Library
export const IRIS_60 = "#A5A6F6";
export const DASHBOARD_SECONDARY = "#849AA9";
export const DASHBOARD_BLUE = "#59A7FF";
export const DASHBOARD_GREEN = "#00C853";
export const DASHBOARD_WHITE = "#FF5252";
export const EMPLOYEE_BLUE = "#3AB5FF";
export const PINK_RED = "#FF5981";
export const ICON_GREY = "#C2CFE0";
export const GRAY = "#90A0B7";
export const RED = "#F7685B";
export const ACCENT_BLUE = "#109CF1";
export const BLACK = "#192A3E";
export const WHITE = "#FFFFFF";
